// import { Button } from 'rsuite';
import { useUser } from '../../contexts/user';
// import DoctorVisitsImage from '../../assets/icons/get_doctor_visit.svg';
import Notimenew from '../../assets/icons/notimenew.svg';
import MyTimes from '../../assets/icons/my_time_green.svg';
import { FofLogin } from '../../components/basic/fof-login';
// import { useQuery } from 'react-query';
// import { IMAGE_BASE_URL, getExpertise } from '../../core';
// import { ExpertyModel } from '../../models/models';
// import { CustomLoader } from '../../components/basic/loader';
// import { useNavigate } from 'react-router-dom';
import { Datepicker } from '@ijavad805/react-datepicker';
import { Input } from 'rsuite';
import { useCallback, useState } from 'react';
import { getMyVisitTimes } from '../../core';
import { CustomLoader } from './../../components/basic/loader';
import { convertToJalali } from '../../utils/helpers';

export const MyVisits = () => {
  // const navigate = useNavigate();
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [visitTimes, setVisitTimes] = useState<any>([]);
  // const expertise = useQuery({
  //   queryKey: ['expertise'],
  //   queryFn: async () => {
  //     const res = await getExpertise();
  //     return res.data.expertise;
  //   }
  // });

  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleGetVisitTimes = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value: any) => {
      (async () => {
        setLoading(true);
        setSelectedDate(value);

        try {
          setVisitTimes([]);
          const { status, data } = await getMyVisitTimes(convertToJalali(new Date(value)));
          if (status === 200) {
            setVisitTimes(data.my_visit_times);
          }
        } catch (e) {
          console.log(e);
        }
        setLoading(false);
      })();
    },
    []
  );
  return (
    <>
      {user.isLoggedIn ? (
        <div className="px-5 pt-3 pb-5 text-base1 text-justify bg-[--rs-gray-50] h-full">
          <div className="flex justify-between items-center mt-5">
            <div className="flex flex-col w-full">
              <span className="mb-1 text-sm">تاریخ موردنظر را انتخاب کنید</span>
              <Datepicker
                lang={'fa'}
                theme={'green'}
                input={
                  <Input
                    className="w-full"
                    placeholder="تاریخ را انتخاب کنید"
                    value={new Intl.DateTimeFormat('fa-IR', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }).format(selectedDate)}
                  />
                } // whatever you want
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onChange={(val: any) => {
                  handleGetVisitTimes(val);
                }}
              />
              {/* <span className="w-[66%] text-center">
                {new Intl.DateTimeFormat('fa-IR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }).format(selectedDate)}
              </span>
              <span className="w-[66%] text-center">
                {new Intl.DateTimeFormat('en-Us', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }).format(selectedDate)}
              </span> */}
            </div>
          </div>
          {loading ? (
            <CustomLoader />
          ) : visitTimes.length ? (
            <>
              {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
              {visitTimes.map((item: any) => {
                return (
                  <div
                    key={item.id}
                    className="shadow-lg p-3 text-center rounded-md bg-[--rs-white] mt-3">
                    <div className="py-1">{item.doctor_name_family}</div>
                    <div className="py-1">{item.visit_request_date}</div>
                    <div className="py-1">{item.visit_time}</div>
                  </div>
                );
              })}
            </>
          ) : (
            <>
              <img src={Notimenew} className="mx-auto mt-5" alt="" />
              <div className="text-center font-base">
                در تاریخ انتخاب شده هیچ نوبت ویزیتی ندارید! با تغییر تاریخ توسط دکمه بالا روز های
                دیگر را نیز برسی کنید.
              </div>
            </>
          )}
        </div>
      ) : (
        // todo
        <FofLogin
          startFromTop={true}
          image={MyTimes}
          text="در این قسمت شما می توانید نوبت های ویزیت حضوری که از پزشک های مختلف گرفته اید را برسی کنید. نوبت ها به ترتیب تاریخ برای شما نمایش داده می شوند."
          redirect="/expertise"
        />
      )}
    </>
  );
};
